<template>
  <div class="vertical-graph">
    <div class="question" v-for="entry in questionsSource">
      <p>
        <strong>{{$index + 1}}: {{entry.question}}</strong>
      </p>
       <div class="legend horisontal">
          <div class="entry" v-if="pre && $index < pre.length">
            <p>
              Før: {{pre[$index].answer}}
            </p>
            <bar :size="pre[$index].answer" :scala="pre[$index].scala" faded></bar>
          </div>
          <div class="entry" v-if="post && $index < post.length">
            <p>
              Efter: {{post[$index].answer}}
            </p>
            <bar :size="post[$index].answer" :scala="post[$index].scala"></bar>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Bar from 'components/Bar'
export default {
  name: 'VerticalGraph',
  components: {
    Bar
  },
  props: {
    pre: {
      type: Array,
      required: true
    },
    post: {
      type: Array,
      required: false
    }
  },
  computed: {
    questionsSource() {
      if (this.pre.length > 0) {
        return this.pre
      } else {
        return this.post
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  margin-top: 2rem;
}
.entry {
  display: flex;
  align-items: center;

  p {
    width: 7rem;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// VerticalGraph.vue?975c0da4